import styled from 'styled-components';
import { lightTheme as theme } from '../../../shared/theme';

export const PageContainer = styled.div`
    background: ${theme.colors.background};
    padding: 24px 32px;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export const PageShell = styled.section`
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    background: ${theme.colors.paper};
    border-radius: 16px;
    border: 1px solid ${theme.colors.gray200};
    box-shadow: ${theme.colors.shadowSm};
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export const HeaderArea = styled.header`
    margin: -24px -24px 0;
    background: ${theme.colors.primary};
    color: ${theme.colors.headerText};
    padding: 20px 24px;
    border-radius: 16px 16px 0 0;

    @media (max-width: 768px) {
        margin: -16px -16px 0;
        padding: 16px;
    }
`;

export const HeaderTitle = styled.h2`
    margin: 0;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    color: ${theme.colors.headerText};
`;

export const BodyText = styled.p`
    margin: 0;
    color: ${theme.colors.text};
    font-size: 14px;
    line-height: 1.6;
`;

export const SectionCard = styled.section`
    background: ${theme.colors.paper};
    border-radius: 12px;
    border: 1px solid ${theme.colors.gray200};
    box-shadow: ${theme.colors.shadowSm};
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SectionTitle = styled.h3`
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: ${theme.colors.primary};
    border-bottom: 1px solid ${theme.colors.border};
    padding-bottom: 8px;
`;

export const KeyValueRow = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    color: ${theme.colors.text};
    font-size: 14px;
    line-height: 1.5;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 4px;
    }
`;

export const KeyLabel = styled.strong`
    min-width: 140px;
    color: ${theme.colors.textSecondary};
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 0.02em;
`;

export const AddressGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const BulletList = styled.ul`
    margin: 0;
    padding-left: 20px;
    color: ${theme.colors.text};
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
        font-size: 14px;
        line-height: 1.6;
    }
`;

export const AlertCard = styled.div`
    border-radius: 12px;
    border: 1px solid
        ${({ $variant }) => {
            if ($variant === 'danger') return theme.colors.danger;
            if ($variant === 'info') return theme.colors.info;
            return theme.colors.warning;
        }};
    background: ${({ $variant }) => {
        if ($variant === 'danger') return theme.colors.dangerBg;
        if ($variant === 'info') return theme.colors.infoBg;
        return theme.colors.warningBg;
    }};
    color: ${theme.colors.text};
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const AlertHeader = styled.div`
    display: inline-flex;
    align-items: center;
    gap: 8px;
`;

export const AlertTitle = styled.h4`
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: ${({ $variant }) => {
        if ($variant === 'danger') return theme.colors.danger;
        if ($variant === 'info') return theme.colors.info;
        return theme.colors.warning;
    }};
`;

export const AlertText = styled.p`
    margin: 0;
    font-size: 13px;
    line-height: 1.55;
    color: ${theme.colors.textSecondary};
`;

export const AlertList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SignatureSection = styled.div`
    border-top: 1px solid ${theme.colors.border};
    padding-top: 12px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;

export const ActionButtonsContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
`;
